import { Gender } from 'src/lib/api';

export enum LocalStorageKeys {
	USER_INFO = 'its-macros-app-user',
	HAS_USER_SEEN_SPLASH_PAGE = 'has-its-macros-app-user-seen-splash-page',
	HAS_USER_FILLED_OUT_START_PAGE = 'has-its-macros-app-user-filled-out-start-page',
	PUSH_TOKEN = 'push-token',
	HAS_USER_SEEN_INITIAL_NOTIFICATION = 'has-its-macros-app-user-seen-initial-notification',
}

// Make sure there is a key in the local i18n object with the value you want to display in the header
// For example -> 'notifications': 'Tilkynningar'
export enum Routes {
	LOG = 'log',
	MENU = 'menu',
	NOTIFICATIONS = 'notifications',
	LOG_IN = 'login',
	NOT_FOUND = 'notfound',
	DIARY_WEEK_LOGS = 'diaryWeekLogs',
	START = 'start',
	SPLASH = 'splash',
	MEASUREMENT_WEEK_LOGS = 'measurementWeekLogs',
	USER_INITIAL_INFO_OVERVIEW = 'userInitialInfoOverview',
	USER_PROFILE = 'profile',
	PROGRESS = 'progress',
	RESET_PASSWORD = 'resetPassword',
	PURCHASE_COURSE = 'purchaseCourse',
	REVIEWS = 'reviews',
	DIARIES = 'diaries',
	MEASUREMENTS = 'measurements',
}

export enum DefaultMacros {
	CARBS = 240,
	PROTEIN = 170,
	FAT = 65,
	FIBER = 30,
}

export enum HungerLevel {
	NO = 0,
	A_LITTLE = 1,
	YES = 2,
}

export enum EnergyLevel {
	LOW = 1,
	MEDIUM = 2,
	HIGH = 3,
}

export enum FoodQualityLevel {
	LOW = 1,
	MEDIUM = 2,
	HIGH = 3,
}

export enum LowPulseExercise {
	NO = 0,
	YES = 1,
}

export enum HighPulseExercise {
	NO = 0,
	YES = 1,
}

export enum HoursOfSleep {
	LESS_THAN_FOUR_HOURS = 4,
	FOUR_TO_FIVE_HOURS = 5,
	FIVE_TO_SIX_HOURS = 6,
	SIX_TO_SEVEN_HOURS = 7,
	SEVEN_TO_EIGHT_HOURS = 8,
	EIGHT_TO_NINE_HOURS = 9,
	NINE_OR_MORE_HOURS = 10,
}

export const MAX_MEASUREMENT_CM = 301;
export const MAX_HEIGHT_CM = 220;
export const MAX_WEIGHT_KG = 499;
export const DEFAULT_HEIGHT_CM = 150;
export const DEFAULT_WEIGHT_KG = 100;
export const DEFAULT_GENDER: Gender = Gender.female;
export const DEFAULT_YEAR = 1970;

export const DEFAULT_MEASUREMENT_VALUE = 50;

export const FACEBOOK_MESSENGER_URL =
	'https://www.messenger.com/t/107378201037044';

export enum SelectedRangeIndex {
	WEEK = 0,
	MONTH = 1,
	TWO_MONTHS = 2,
}
